import { render, staticRenderFns } from "./OuterRoof.vue?vue&type=template&id=3b1835ea"
import script from "./OuterRoof.vue?vue&type=script&lang=js"
export * from "./OuterRoof.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports